<template>
  <div class="body-field main">
    <AppHeader 
      v-if="route.meta.headerType !== 'none'"
      :type="route.meta.headerType || 'main'" 
      :title="route.meta.title" 
      @back="handleBack"
      @home="handleHome"
      @menu="handleMenu"
    />
    <div class="content-area">
      <RouterView />
    </div>
  </div>
</template>

<script setup>
import AppHeader from './components/AppHeader.vue';
import { ref, watch, onMounted, computed, provide } from 'vue';
import { useRoute, useRouter } from 'vue-router';
const $bridge = window.$bridge; // 전역 객체 사용
const route = useRoute();
const router = useRouter();
const isIOSDevice = ref(false);

const customBackAction = ref(null);


provide('setBackAction', (fn) => {
  customBackAction.value = fn;
});

const handleBack = () => {
  if (customBackAction.value) {
    customBackAction.value();
    return;
  }else{
    router.back();
  }
  
};

const handleHome=()=>{
  
   $bridge.closeWebView(); //네이티브 브리지로 작성해야함 
}


const handleMenu=()=>{
  
  router.push("/support/menu")
}


function checkIOS(){
  if(typeof window === 'undefined') return false;

  const ua = window.navigator.userAgent;
  const platform = window.navigator.platform;

  return (
    /iPhone|iPad|iPod/i.test(ua)||(platform === 'MacIntel' && window.navigator.maxTouchPoints > 1)
  );
}

onMounted(()=>{
  isIOSDevice.value = checkIOS();
  document.documentElement.classList.add(isIOSDevice.value ? "device-ios" : "device-aod")
})

</script>

<style lang="scss">

// nav {
//   padding: 30px;

//   a {
//     font-weight: bold;
//     color: #2c3e50;

//     &.router-link-exact-active {
//       color: #42b983;
//     }
//   }
// }
</style>
